import { render, staticRenderFns } from "./WoodberryWetlands.vue?vue&type=template&id=6a6f99ad&"
import script from "./WoodberryWetlands.vue?vue&type=script&lang=js&"
export * from "./WoodberryWetlands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports